import { withDefaultContextAsSelectedProject } from './api-default-context';

export const mapElementsRequest = ({
  targetId,
  sourceId,
  targetStatementId,
  sourceStatementId,
  elementMapDetails,
}) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/statements/source/${sourceStatementId}/target/${targetStatementId}/revisions/source/${sourceId}/target/${targetId}/map`,
      elementMapDetails,
    )
    .then((response) => {
      return response;
    });
};

export const autoTieoutProcessRequest = ({
  targetClientId,
  targetRevisionId,
  sourceRevisionId,
  targetStatementId,
  sourceStatementId,
  autoTieoutWorkPaper,
  workFlowStatus,
}) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/client/${targetClientId}/statements/source/${sourceStatementId}/target/${targetStatementId}/revisions/source/${sourceRevisionId}/target/${targetRevisionId}/autotieout/workflow`,
      autoTieoutWorkPaper,
    )
    .then((response) => {
      return response;
    });
};

export const autoTieoutWorkFlowRequest = ({
  targetRevisionId,
  sourceRevisionId,
  targetStatementId,
  sourceStatementId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/statements/source/${sourceStatementId}/target/${targetStatementId}/revisions/source/${sourceRevisionId}/target/${targetRevisionId}/autotieout/workflow`,
    )
    .then((response) => {
      return response;
    });
};

export const autoTieoutRetryRequest = (workflowData) => {
  return withDefaultContextAsSelectedProject()
    .post(`/tieout/autotieout/workflow/retry`, workflowData)
    .then((response) => {
      return response;
    });
};

export const getWorkpaperByAutoTieoutStatement = ({
  statementId,
  revisionId,
  workPaperId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/statements/${statementId}/revisions/${revisionId}/wprefs/${workPaperId}/info`,
    )
    .then((response) => {
      return response;
    });
};
